export const DOCTOR_ROLE = "DOCTOR";
export const PATIENT_ROLE = "PATIENT";
